const { EncryptStorage } = require('encrypt-storage');

var options = {};

const encryptStorage = EncryptStorage('0123456789', options);

module.exports = encryptStorage